import React, { PropTypes, Component } from 'react'
import ReactDOM from 'react-dom'
import styles from './styles'
import classNames from 'classnames'
import ItemBox from './itemBox'
import misc from 'utils/misc'


export default class AutoComplete extends Component {
  static propTypes = {
    items: PropTypes.array,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    redHighlight: PropTypes.bool,
    wide: PropTypes.bool,
    medium: PropTypes.bool,
    narrow: PropTypes.bool,
    expand: PropTypes.bool,
    centerText: PropTypes.bool,
    onSelect: PropTypes.func,
    value: PropTypes.string,
    itemIndex: PropTypes.number,
    allowNonItems: PropTypes.bool,
    onFocusNext: PropTypes.func,
    dropDown: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
    itemIndex: -1,
  };

  constructor (props) {
    super(props)
    this.onBlur = ::this.onBlur
    this.onChange = e => {
      const { dropDown, allowNonItems, items } = this.props
      const filter = e.target.value

      let filteredItems
      if (dropDown && filter === '') {
        filteredItems = items
      } else {
        filteredItems = misc.getFilteredItems(items, filter)
      }

      let itemIndex = filteredItems.length > 0 ? 0 : -1
      if (allowNonItems) {
        itemIndex = -1
      }
      this.setState({ show: true, filter: e.target.value, itemIndex, filteredItems })
    }

    this.onFocus = () => {
      if (this.props.dropDown) {
        this.setState({ show: true, filter: '' })
      } else {
        this.refs.input.select()
      }
    }
    this.genOnSelect = ::this.genOnSelect
    this.scrollItemIntoView = ::this.scrollItemIntoView
    this.focus = () => this.refs.input.focus()
    this.blur = () => this.refs.input.blur()
    this.onItemBoxMousedown = (e) => {
      e.preventDefault()
      return false
    }
  }

  state = {
    show: false,
    filter: this.props.value,
    filteredItems: this.props.items,
    itemIndex: this.props.items.indexOf(this.props.value),
  };

  componentWillReceiveProps (nextProps) {
    if (this.state.filter !== nextProps.value || this.props.items !== nextProps.items) {
      this.setState({
        show: false,
        filter: nextProps.value,
        filteredItems: nextProps.items,
        itemIndex: nextProps.items.indexOf(nextProps.value),
      })
    }
  }

  onBlur () {
    // give time for onSelect(), delaying the itemBoxList disappear
    window.setTimeout(() => {
      if (!this || !this.state.show) {
        return
      }
      this.setState({ show: false })
      const { onSelect, allowNonItems, items } = this.props
      if (!allowNonItems) {
        if (this.state.itemIndex === -1) {
          onSelect('', -1)
        } else {
          const itemText = this.state.filteredItems[this.state.itemIndex]
          const itemIndexInAll = items.indexOf(itemText)
          onSelect(itemText, itemIndexInAll)
          this.setState({ filter: itemText })
        }
      } else {
        const itemIndex = items.indexOf(this.refs.input.value)
        onSelect(this.refs.input.value, itemIndex)
      }
    }, 200)
  }

  onNavigateItem (filteredItems, shift) {
    if (filteredItems.length > 0) {
      let itemIndex = this.state.itemIndex
      itemIndex = (itemIndex + filteredItems.length + shift) % filteredItems.length
      this.setState({ itemIndex })
      if (itemIndex < 10) {
        this.scrollItemIntoView(itemIndex)
      } else {
        this.scrollItemIntoView(itemIndex)
      }
    }
  }

  onEsc () {
    this.blur()
  }

  onTabEnter (filteredItems) {
    const { allowNonItems, onFocusNext, onSelect, items } = this.props
    const input = this.refs.input
    let itemIndex = this.state.itemIndex
    let itemIndexInAll = -1

    if (itemIndex === -1) {
      itemIndex = filteredItems.indexOf(input.value)
    }
    if (itemIndex !== -1) {
      itemIndexInAll = items.indexOf(filteredItems[itemIndex])
    } else {
      itemIndexInAll = items.indexOf(input.value)
    }

    if (itemIndex === -1) {
      if (allowNonItems) {
        onSelect(input.value, -1)
      } else {
        onSelect('', -1)
      }
    } else {
      const itemText = filteredItems[itemIndex]
      onSelect(itemText, itemIndexInAll)
      this.setState({ filter: itemText })
    }
    if (onFocusNext) {
      onFocusNext(this)
    }
  }

  // 中文輸入法下 keydown keyup issue http://www.cnblogs.com/owenChen/p/3215421.html
  genOnKeyDown (filteredItems) {
    return e => {
      switch (e.keyCode) {
        case 27: // esc
          this.onEsc()
          break

        case 9: // enter/tab
          this.onTabEnter(filteredItems)
          if (this.onFocusNext) {
            e.preventDefault()
          }
          break
        case 13:
          this.onTabEnter(filteredItems)
          e.preventDefault()
          break

        case 40: // down
          this.onNavigateItem(filteredItems, 1)
          break

        case 38: // up
          this.onNavigateItem(filteredItems, -1)
          break
        default:
      }
    }
  }

  scrollItemIntoView (itemIndex) {
    ReactDOM.findDOMNode(this.refs[`item${itemIndex}`])
      .scrollIntoView(false)
  }

  genOnSelect (item) {
    return () => {
      this.setState({ show: false, filter: item })
      if (this.props.onSelect) {
        this.props.onSelect(item, this.props.items.indexOf(item))
      }
    }
  }


  render () {
    const {
      placeholder,
      redHighlight,
      wide,
      medium,
      narrow,
      expand,
      centerText,
    } = this.props

    const { show, filter, itemIndex, filteredItems } = this.state

    return (
      <div
        tabIndex="-1"
        className={classNames(styles.autoComplete, {
          [styles.wide]: wide,
          [styles.medium]: medium,
          [styles.narrow]: narrow,
          [styles.expand]: expand,
        })}
      >
        <input
          ref="input"
          value={filter}
          placeholder={placeholder}
          className={classNames({
            [styles.redHighlight]: redHighlight,
            [styles.centerText]: centerText,
          })}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onKeyDown={this.genOnKeyDown(filteredItems)}
        />
        {filteredItems.length > 0 && show ?
          <div
            onMouseDown={this.onItemBoxMousedown}
            className={styles.itemListBox}
          >
            {
              filteredItems.map((item, i) =>
                <ItemBox
                  ref={`item${i}`}
                  key={item}
                  selected={i === itemIndex}
                  onClick={this.genOnSelect(item)}
                  item={item}
                />
              )
            }
          </div> : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/autocomplete/index.jsx